import { CdkPortalOutlet, DomPortal } from '@angular/cdk/portal';
import {
   AfterViewInit,
   ChangeDetectionStrategy,
   Component,
   ElementRef,
   Input,
   OnDestroy,
   ViewChild,
} from '@angular/core';
import { YAxisTicksComponent as NgxChartsYAxisTicksComponent } from '@swimlane/ngx-charts';
import { Orientation } from '../graphs/models/orientation.enum';

/**
 * Component that renders the y-axis ticks and reference lines.
 * Optionally accepts a portal outlet to render custom reference lines into,
 * which allows reference lines to be rendered elsewhere within a chart.
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'g[qmg-charts-y-axis-ticks]',
    templateUrl: './y-axis-ticks.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class YAxisTicksComponent extends NgxChartsYAxisTicksComponent implements AfterViewInit, OnDestroy {
   @Input() referenceLinesOutlet?: CdkPortalOutlet;

   @ViewChild('referenceLinesEl', { read: ElementRef }) referenceLinesEl: ElementRef;

   readonly Orientation = Orientation;

   ngAfterViewInit(): void {
      super.ngAfterViewInit();

      this.referenceLinesOutlet?.attach(new DomPortal(this.referenceLinesEl.nativeElement));
   }

   ngOnDestroy(): void {
      // Only detach, not dispose, because the outlet is not a part of this component and may be reused.
      this.referenceLinesOutlet?.detach();
   }
}
